import { toast } from "react-toastify";
import { formatDate } from "../../utils/rawData/dateValues";
import { ClientTypeColor, PercetageColor, GetStatusClass, PlanBackgroundColor, GetDynamicColor, formMapColor, facturacionMapColor, infoEnviadaMapColor, delayResponsibleMapColor, capacitacionHechaMapColor, statusColorMap, vipClientColor } from "../../utils/GetTextColor";
import DetailsButton from "../ui/components/DetailsButton";
import { FaComment, FaEye, FaEyeSlash } from "react-icons/fa";
import Tooltip from "../ui/ToolTip";
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";
import { useRef, useState, useEffect } from "react";
import HandleUpdateSelect from "../../utils/HandleUpdateSelect";
import IdButton from "../ui/components/IdButton";
import CopyToClipBoard from "../../utils/CopyToClipBoard";
import { standardServiceStatus } from "../../utils/rawData/serviceStatus";
import OpcionesRecompraPotencial from "../../utils/plainValues/OpcionesRecompraPotencial";
import DinamicBoxButton from "../ui/components/DinamicBoxButton";
import { vipClientValues } from "../../utils/rawData/vipClientValues";
import { createPortal } from "react-dom";
import DrawerCotizacionCalendarioPagosDetails from "../calendarioPagos/DrawerCotizacionCalendarioPagosDetails";
import React from "react";


const SoporteRowItemContainer = ({ serviceData, key, c, activeCols, shouldShowColumn, stickyOffsets, user, permissions, setOpenModalDescription, setSelectedService, setOpenModalComments, setOpenModalClientData, setSelectedClientData, suppServices, setClients }) => {

  const [s, setS] = useState(serviceData)
  
  // Mantener sincronizado el estado local con los cambios del padre
  useEffect(() => {
    setS(serviceData)
  }, [serviceData])
  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  // Drawer cotización
  const [openDrawer, setOpenDrawer] = useState(false);
  const [dataDrawer, setDataDrawer] = useState(null);

  const handleOpenDrawer = async (id) => {
    try {
      const response = await axios.get(`${BACKEND}/api/cotizaciones/${id}`)
      setDataDrawer(response.data)
      setOpenDrawer(true)
    } catch (error) {
      toast.error("Error al obtener la cotización")
    }
  }

  const checklistCompleted = s.checklistCompleted || s.checkList === "Si" ? "Si" : "No"

  const linkDisenioGrafico = s.linkDisenioGrafico || ""
  const linkOficial = s?.links?.find((l) => l.titulo === "Link web oficial")?.url

  // Modificación de seleccionables, ya no es solo lectura
  const handleUpdateField = async (field, newStatus) => { // Cambiar el campo
    const changeHistory = s.historialCambios ? [...s.historialCambios] : [];

    const newChange = {
      worker: user,
      field: field,
      oldValue: s[field],
      newValue: newStatus,
      date: new Date().toISOString(),
    };

    changeHistory.push(newChange);

    const transformedHistory = changeHistory.map(change => ({
      ...change,
      worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
    }));

    try {
      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${s.id}`, {
        [field]: newStatus === "Seleccionar" ? null : newStatus,
        historialCambios: transformedHistory, // Enviar el array actualizado
      });

      // Crear el servicio actualizado
      const updatedService = {
        ...s,
        [field]: newStatus,
        historialCambios: changeHistory,
      };

      // Actualizar el estado local
      setS(updatedService);

      // Actualizar el servicio específico en el array de clientes
      setClients((prevClients) => 
        prevClients.map(client => 
          client.id === c.id 
            ? {
                ...client,
                services: client.services.map(service => 
                  service.id === s.id ? updatedService : service
                )
              }
            : client
        )
      );

      toast.success("Estado actualizado con éxito");
    } catch (error) {
      console.error(error);
      toast.error("Error al actualizar el estado");
    }
  };

  // Modificación de inputs, ya no es solo lectura
  const handleUpdateDate = (field, newDate) => { // Cambiar la fecha con lógica de debouncer

    setS((prevData) => ({
      ...prevData,
      [field]: newDate,
    }));

    if (debounceUpdate.current) {
      clearTimeout(debounceUpdate.current);
    }
    debounceUpdate.current = setTimeout(async () => {

      try {
        const changeHistory = s.historialCambios ? [...s.historialCambios] : [];

        const newChange = {
          worker: user,
          field: field,
          oldValue: s[field],
          newValue: newDate,
          date: new Date().toISOString(),
        };

        changeHistory.push(newChange);

        const transformedHistory = changeHistory.map(change => ({
          ...change,
          worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
        }));

        await axios.put(`${BACKEND}/api/serviciosCotizaciones/${s.id}`, {
          [field]: newDate || null,
          historialCambios: transformedHistory, // Enviar el array actualizado
        });

        // Crear el servicio actualizado
        const updatedService = {
          ...s,
          [field]: newDate,
          historialCambios: changeHistory,
        };

        // Actualizar el estado local
        setS(updatedService);

        // Actualizar el servicio específico en el array de clientes
        setClients((prevClients) => 
          prevClients.map(client => 
            client.id === c.id 
              ? {
                  ...client,
                  services: client.services.map(service => 
                    service.id === s.id ? updatedService : service
                  )
                }
              : client
          )
        );

        toast.success("Dato actualizado con éxito");
      } catch (error) {
        console.error(error);
        toast.error("Error al actualizar la fecha");
      }
    }, 1000); // Esperar 1 sec luego de que el usuario deja de escribir
  };

  // Column definitions (ordered). IDs are assigned automatically as index + 1
  const cols = [
    // 1) Cotización
    {
      content: () => (
        <td className={`px-2 py-1 max-w-[3.5rem] min-w-[3.5rem] w-[3.5rem] ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } z-10 sticky font-semibold border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100`} style={{ left: stickyOffsets?.first || '0rem' }}>
          <div className="flex justify-center items-center gap-2">
            <DetailsButton
              content={"Abrir cotización"}
              type="eye"
              action={() => handleOpenDrawer(s.cotizacion?.id)}
            />
          </div>
        </td>
      ),
    },

    // 2) Porcentaje proyecto
    {
      content: () => (
        <td className={`px-2 py-1 max-w-[6.2rem] min-w-[6.2rem] w-[6.2rem] ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } z-10 max-w-xs sticky border border-gray-300 truncate font-bold text-center ${GetDynamicColor(s.porcentajeAvance, PercetageColor)}`} style={{ left: stickyOffsets?.second || '3.5rem' }}>
          <input
            type="number"
            value={s.porcentajeAvance ? s.porcentajeAvance : 0}
            min={0}
            max={100}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            onChange={(e) => {
              let value = parseInt(e.target.value, 10);
              if (isNaN(value)) value = 0;
              if (value < 0) value = 0;
              if (value > 100) value = 100;
              handleUpdateDate("porcentajeAvance", value);
            }}
            onWheel={(e) => e.target.blur()}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300 w-full ${GetDynamicColor(s.porcentajeAvance, PercetageColor)}`}
          />
        </td>
      ),
    },

    // 3) Cliente
    {
      content: () => (
        <td className={`sticky px-2 py-1 max-w-[15rem] ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } font-semibold border border-gray-300 truncate text-start hover:cursor-pointer hover:underline transition-all duration-100 z-10`} style={{ left: stickyOffsets?.third || '9.7rem' }}>
          <a href={`/home/seguimiento/${c.id}`} target="_blank" rel="noopener noreferrer">
            <span title={c.nombreComercial} className="whitespace-nowrap text-xs">{c.nombreComercial}{c.vip === "Si" && " ⭐"}</span>
          </a>
        </td>
      ),
    },

    {
      content: () => (
        <td className={`px-2 py-1 max-w-xs font-semibold border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100`}>
          <div className="flex justify-center items-center gap-2">
            <a
              href={`/home/seguimiento/${serviceData.cotizacion.cliente.id}/${serviceData.servicio.name}/${serviceData.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-row justify-center items-center gap-2 font-bold hover:cursor-pointer hover:underline transition-all duration-100"
            >
              <DetailsButton content={"Ir al proyecto"} type="externalLink"/>
            </a>
          </div>
        </td>
      ),
    },

    // 4) Tipo soporte web
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.servicio?.name}
        </td>
      ),
    },

    // 5) VIP
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <select
            value={s.cotizacion?.cliente?.vip}
            disabled={!permissions.isAdmin && !permissions.isAssistant}
            className={`text-xs w-[7rem] rounded-md px-2 py-1 border border-gray-300 ${vipClientColor[s.cotizacion?.cliente?.vip]}`}
            onChange={(e) => {
              HandleUpdateSelect("vip", e.target.value, s.cotizacion?.cliente?.id, "clientesUser", setClients)
              setS((prev) => ({
                ...prev,
                cotizacion: {
                  ...prev.cotizacion,
                  cliente: { ...prev.cotizacion?.cliente, vip: e.target.value }
                }
              }))
            }}
          >
            {vipClientValues.map((option) => (
              <option value={option.value} className={`${vipClientColor[option.value]}`}>{option.icon} {option.label}</option>
            ))}
          </select>
        </td>
      ),
    },

    // 6) Datos cliente
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            <DetailsButton
              action={() => {setOpenModalClientData(true); setSelectedClientData(serviceData)}}
              content={"Abrir datos del cliente"}
            />
          </div>
        </td>
      ),
    },

    // 7) Regalo(?)
    {
      content: () => (
        <td className={`${s.servicioGratuito ? "bg-green-500 font-bold text-white" : "text-gray-200" } px-2 py-1 max-w-xs border border-gray-300 truncate text-center`}>
          {s.servicioGratuito ? `Gratis 🎁` : "No"}
        </td>
      ),
    },

    // 8) Recompra potencial
    {
      content: () => (
        <td className={`px-2 py-1 max-w-xs ${s.debt ? "bg-red-200" : "bg-white" } border border-gray-300 truncate text-center`}>
          <select
            value={s.cotizacion?.cliente?.recompraPotencial}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            onChange={(e) => {
              HandleUpdateSelect("recompraPotencial", e.target.value, s.cotizacion?.cliente?.id, "clientesUser", setClients)
              setS((prev) => ({
                ...prev,
                cotizacion: {
                  ...prev.cotizacion,
                  cliente: { ...prev.cotizacion?.cliente, recompraPotencial: e.target.value }
                }
              }))
            }}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          >
            {OpcionesRecompraPotencial.map((value) => (
              <option value={value.value} className={`${value.color}`}>{value.icon} {value.label}</option>
            ))}
          </select>
        </td>
      ),
    },

    // 9) Moroso
    {
      content: () => (
        <td className={`px-2 py-1 max-w-xs border border-gray-300 truncate text-center`}>
          <div className="flex justify-center items-center gap-2">
            {s.debt ? (
              <span className="text-red-500 font-bold">Si</span>
            ) : (
              <span className="text-gray-200">No</span>
            )}
          </div>
        </td>
      ),
    },

    // 10) ID Cotización
    {
      content: () => (
        <td className={`px-2 py-1 max-w-xs font-semibold border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100`}>
          <div className="flex justify-center items-center gap-2">
            <IdButton content={s.cotizacion.id} type="id" action={() => {CopyToClipBoard(s.cotizacion.id)}} />
          </div>
        </td>
      ),
    },

    // 11) Cotización
    {
      content: () => (
        <td className={`px-2 py-1 max-w-xs ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } font-semibold border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100`}>
          <div className="flex justify-center items-center gap-2">
            <DetailsButton
              content={"Abrir cotización"}
              type="eye"
              action={() => handleOpenDrawer(s.cotizacion?.id)}
            />
          </div>
        </td>
      ),
    },

    // 12) Estado
    {
      content: () => (
        <td className={`px-2 py-1 border border-gray-300 text-center align-middle`}>
          <select
            value={s.estado}
            onChange={(e) => {
              const newValue = e.target.value
              const hasNoPermissions = !permissions.isAdmin && !permissions.isAssistant && !permissions.isUserArea
              if (hasNoPermissions && newValue === "Terminado con exito") {
                return
              }
              handleUpdateField("estado", newValue)
            }}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300 
              ${(!permissions.isAdmin && !permissions.isAssistant && !permissions.isUserArea) ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}
              ${statusColorMap[s.estado] || ""}
            `}
            disabled={(!permissions.isAdmin && !permissions.isAssistant && !permissions.isUserArea) && s.estado !== "Terminado con exito"}
            title={(!permissions.isAdmin && !permissions.isAssistant && !permissions.isUserArea) ? "No tienes permiso para editar el estado" : ""}
          >
            {standardServiceStatus.map((status, index) => (
              <option key={index} value={status.value} className={`${status.color} hover:cursor-pointer`}>{status.icon} {status.label}</option>
            ))}
          </select>
        </td>
      ),
    },

    // 13) Enfoque web
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <span className={`${infoEnviadaMapColor[s.informacionEnviada]}`}>
            <select
              value={s.enfoqueWeb}
              onChange={(e) => {
                handleUpdateField("enfoqueWeb", e.target.value);
              }}
              className={`text-xs rounded-md px-2 py-1 border border-gray-300 ${s.enfoqueWeb === "Normal" ? "text-blue-500" : s.enfoqueWeb === "Ads" ? "text-green-500" : "text-gray-500"}`}
              disabled={!permissions.isAdmin && !permissions.isUserArea}
            >
              <option value="No definido" className="text-gray-500">⚫ No definido</option>
              <option value="Ads" className="text-green-500">🟢 Ads</option>
              <option value="Normal" className="text-blue-500">🔵 Normal</option>
            </select>
          </span>
        </td>
      ),
    },

    // 14) Descripción servicio
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            <DetailsButton
              action={() => {setOpenModalDescription(true); setSelectedService(s)}}
              content={"Abrir descripción del servicio"}
            />
          </div>
        </td>
      ),
    },

    // 15) Comentarios vendedor
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            {s.comentarioVendedor ? (
              <Tooltip content={s.comentarioVendedor} interactive={true}>
                <div className="flex justify-center items-center text-gray-800 hover:cursor-pointer">
                  <FaComment />
                </div>
              </Tooltip>
            ) : (
              <div className="flex justify-center items-center text-gray-200">
                <FaComment />
              </div>
            )}
          </div>
        </td>
      ),
    },

    // 16) Comentarios operativa
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            <DinamicBoxButton
              color={s?.comentariosOperativa?.length > 0 ? "blue" : "gray"}
              action={() => {setOpenModalComments(true); setSelectedService(s)}}
              content={`Abrir comentarios del área operativa: ${s?.comentariosOperativa?.length > 0 ? `${s?.comentariosOperativa?.length}` : "0"}`}
              icon={s?.comentariosOperativa?.length > 0 ? <FaEye /> : <FaEyeSlash />}
            />
          </div>
        </td>
      ),
    },

    // 17) Plan
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <span className={`font-semibold px-2 ${PlanBackgroundColor[s.planServicio.name]}`}>
            {s.planServicio.name}
          </span>
        </td>
      ),
    },

    // 18) Encargado
    {
      content: () => (
        <td className="max-w-[11rem] px-2 py-1 border border-gray-300 truncate text-start">
          <span title={s.cotizacion?.cliente?.encargadoProyecto}>{s.cotizacion?.cliente?.encargadoProyecto ? `${s.cotizacion?.cliente?.encargadoProyecto}` : "-"}</span>
        </td>
      ),
    },

    // 19) Nro encargado
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.cotizacion?.cliente?.telefono ? `${s.cotizacion?.cliente?.telefono}` : "-"}
        </td>
      ),
    },

    // 20) Tipo cliente
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <select
            value={s.cotizacion?.cliente?.tipoCliente}
            onChange={(e) => {
              const newValue = e.target.value
              if ((!permissions.isAdmin && !permissions.isUserArea) && newValue === "Terminado con exito") {
                return
              }
              HandleUpdateSelect("tipoCliente", e.target.value, s.cotizacion?.cliente?.id, "clientesUser", setClients)
              setS((prev) => ({
                ...prev,
                cotizacion: {
                  ...prev.cotizacion,
                  cliente: { ...prev.cotizacion?.cliente, tipoCliente: e.target.value }
                }
              }))
            }}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          >
            <option value="No definido" className="text-gray-500">⚫ No definido</option>
            <option value="Amable" className="text-green-500">🟢	Amable</option>
            <option value="Normal" className="text-blue-500">🔵	 Normal</option>
            <option value="Problematico" className="text-red-500">🔴	 Problematico</option>
          </select>
        </td>
      ),
    },

    // 21) Responsable
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.responsable?.name ? `${s.responsable?.name}` : "-"}
        </td>
      ),
    },

    // 22) Checklist
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <span className={`${checklistCompleted === "Si" ? "text-green-500" : "text-red-500"}`}>
            {checklistCompleted}
          </span>
        </td>
      ),
    },

    // 23) Fecha venta o ingreso
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.fechaIngreso ? formatDate(s.fechaIngreso.split("T")[0]) : "-"}
        </td>
      ),
    },

    // 24) Fecha inicio proyecto
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaInicio ? s.fechaInicio.split('T')[0] : ""}
            onChange={(e) => handleUpdateDate("fechaInicio", e.target.value)}
            disabled={!(permissions.isAdmin)}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 25) Fecha fin proyecto
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaFin ? s.fechaFin.split('T')[0] : ""}
            onChange={(e) => handleUpdateDate("fechaFin", e.target.value)}
            disabled={!(permissions.isAdmin)}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 26) Precio venta
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {(() => {
            const servicioEncontrado = suppServices.find(
              (e) => e.id === s.servicio.id
            );

            const precioUnitario = servicioEncontrado?.preciosUnitarios?.find(
              (ev2) => ev2.plan?.id === s.planServicio?.id
            )?.precio;

            const precioBase = s.customPriceActive
              ? s.customPrice * s.numeroItems
              : precioUnitario
              ? precioUnitario * s.numeroItems
              : 0;

            let montoDescuento = 0;
            if (s.tipoDescuento === "Porcentaje") {
              montoDescuento = precioBase * (s.montoDescuento / 100);
            } else if (s.tipoDescuento === "Fijo") {
              montoDescuento = s.montoDescuento;
            }

            return "S/. " + (precioBase - montoDescuento).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          })()}
        </td>
      ),
    },

    // 27) Vendedor
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.cotizacion?.cotizador?.name ? `${s.cotizacion?.cotizador?.name}` : "-"}
        </td>
      ),
    },

    // 28) Link oficial
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkOficial ? (
              <DetailsButton
                action={() => {window.open(linkOficial, "_blank")}}
                content={linkOficial ? linkOficial : "No hay link oficial"}
              >
                {linkOficial ? linkOficial : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 29) Control de calidad
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <select
            value={s.controlCalidad}
            disabled={!permissions.isAdmin && !permissions.isAssistant}
            onChange={(e) => {handleUpdateField("controlCalidad", e.target.value)}}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          >
            <option value="Pendiente" className="text-gray-500">Pendiente</option>
            <option value="Si" className="text-green-500">Si</option>
            <option value="No" className="text-red-500">No</option>
          </select>
        </td>
      ),
    },

    // 30) Link diseño gráfico
    {
      content: () => (
        <td className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkDisenioGrafico ? (
              <DetailsButton
                action={() => {window.open(linkDisenioGrafico, "_blank")}}
                content={linkDisenioGrafico ? linkDisenioGrafico : "No hay link oficial"}
              >
                {linkDisenioGrafico ? linkDisenioGrafico : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },
  ]

  const colsWithIds = cols.map((col, index) => ({ ...col, id: index + 1 }))

  return (
    <>
      {createPortal(
        <DrawerCotizacionCalendarioPagosDetails
          onClose={() => setOpenDrawer(false)}
          open={openDrawer}
          dataDrawer={dataDrawer}
          refetch={() => {}}
          isAdmin={permissions.isAdmin}
          paises={[]}
          currencyExchanges={[]}
        />,
        document.body
      )}
      <tr
        key={key}
        className={`text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300 ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" }`}
      >

        {/* Columnas dinámicas (ids 1..N) */}
        {colsWithIds.map((colDef) => {
          const isVisible = activeCols?.find((c) => c.id === colDef.id && shouldShowColumn(c))
          if (!isVisible) return null
          return React.cloneElement(colDef.content(), { key: colDef.id })
        })}

      </tr>
    </>
  )
}

export default SoporteRowItemContainer;